/** Counted progress of a CAD publication. The server never estimates: while some sheets are not
 * planned yet the total is only the part that is known, and the text says so. */
export function publicationProgress(publication:{status:string;pages_done?:number|null;pages_planned?:number|null;plan_complete?:boolean|null}|undefined):string {
  if(!publication || publication.status==='ready') return '';
  const {pages_done:done,pages_planned:planned,plan_complete:complete}=publication;
  if(done==null || planned==null) return ['queued','running'].includes(publication.status) ? 'Страницы ещё размечаются: счёт появится после первой готовой страницы.' : '';
  return complete ? `Готово ${done} из ${planned} страниц.` : `Готово ${done} из ${planned} размеченных страниц. Остальные листы ещё размечаются, итог уточняется.`;
}

export type PdfPage={source_id:string;page:number;sheet:string};

/** Neighbouring pages of a PDF original; the list is already in page order. */
export function pdfNeighbours(pages:PdfPage[],currentId:string):{index:number;previous?:PdfPage;next?:PdfPage} {
  const index=pages.findIndex(page=>page.source_id===currentId);
  if(index<0) return {index};
  return {index,previous:pages[index-1],next:pages[index+1]};
}

export type Opening='prepare'|'first'|'repeat';
const opened=new Set<string>();

/** «prepare» — the pages had to be published first (cold opening); «first» — first opening of this
 * page in the browser session; «repeat» — opened again. Called once per painted page. */
export function openingKind(identity:string,waitedForPages:boolean,seen:Set<string>=opened):Opening {
  const known=seen.has(identity);
  seen.add(identity);
  return waitedForPages ? 'prepare' : known ? 'repeat' : 'first';
}

/** A measurement is sent as it was taken or not at all. */
export function timingBody(pageId:string,opening:Opening,started:number,painted:number):{page_id:string;opening:Opening;ms:number}|undefined {
  const ms=Math.round(painted-started);
  if(!pageId || !Number.isFinite(ms) || ms<0 || ms>3_600_000) return undefined;
  return {page_id:pageId.slice(0,200),opening,ms};
}
